import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8fb3bc96"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "result-list" }
const _hoisted_2 = {
  key: 1,
  class: "NationalSearch"
}
const _hoisted_3 = { class: "viewport" }
const _hoisted_4 = { class: "rel" }
const _hoisted_5 = { class: "flex-cen" }

import { ref, watch, reactive, computed, onMounted } from 'vue'
import { t } from '@/plugins/i18n'
import Category from '@/components/bussiness/Category/Category.vue'
import ListLabel from './components/ListLabel.vue'
import ListSort from './components/ListSort.vue'
import ListGrid from './components/ListGrid.vue'
import ShopHeader from './components/ShopHeader.vue'
import SimilarGoods from './components/SimilarGoods.vue'
import Marking from './components/Marking.vue'
import ImageSearchGoods from './components/imageSearchGoods.vue'
import suggestDioalog from './components/suggestDioalog.vue'
import SuggestInput from './components/SuggestInput.vue'
import NationalSearch from './components/NationalSearch.vue'
import { ElMessage } from 'element-plus'
import { confirmLoginWithNoCurShop } from '@/util/useConfirm'
import { keywordList } from '@/views/product/CreateAssociated/components/CommonProduct/useCommonProduct'
import {
  searchSimilar,
  searchSuppliers,
  searchProducts,
  searchList,
  checkAgree
} from '@/apis/search'
import { useGlobal } from '@/util/useLoading'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { isJA, useSite2Station } from '@/store'
import { Site } from '@/common/const'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const loading = ref(false)
const stationCode = useSite2Station()
/** 是否展示建议 */
const showSuggest = ref(false)
/** 建议输入框 */
const showInputSuggest = ref(false)
/** 关闭弹窗 */
const closeSuggest = (val: string | number) => {
  if (val === '') {
    showSuggest.value = false
  }
  if (val === 1) {
    const { keyword, filters, categoryId } = route.query
    checkAgree({ agreeFlag: 1, keyWords: keyword?.toString(), filters: filters?.toString(), categoryId: categoryId?.toString() }).then(res => {
      if (res.success) {
        showSuggest.value = false
        ElMessage.success(t('感谢您的宝贵意见'))
      }
    })
  }
  if (val === 0) {
    showInputSuggest.value = true
  }
}
/** 输入框提交 */
const sureSuggest = (val: string) => {
  if (val) {
    const { keyword, filters, categoryId } = route.query
    checkAgree({ agreeFlag: 0, comments: val, keyWords: keyword?.toString(), filters: filters?.toString(), categoryId: categoryId?.toString() }).then(res => {
      if (res.success) {
        showInputSuggest.value = false
        showSuggest.value = false
        ElMessage.success(t('感谢您的反馈'))
      }
    })
  } else {
    showInputSuggest.value = false
  }
}
// 请求拦截
const fragLoad = false
const api = useGlobal(() => {
  const req: any = [
    // 相似商品
    ['productCode', searchSimilar, (res: any) => (data.value = res.data)],
    // 店铺商品列表
    [
      'shopCode',
      searchSuppliers,
      (res: any) => {
        data.value = res.data.productPage
        const result = res.data.supplierRespDTO
        const shopMajorCateName = {
          [Site.JA]: result.shopMajorCateNameJp,
          [Site.KO]: result!.shopMajorCateNameKr,
          [Site.EN]: result!.shopMajorCateNameEn
        }[stationCode] as string
        componentData.shopDetail = {
          ...result,
          shopMajorCateName
        }
      }
    ],
    // 图搜
    [
      'imageId',
      searchList,
      (res: any) => (data.value = res.data)
    ]
  ].find(([k]) => !!params.value[k]) ||
    // 关键字
    [
      'keyword',
      searchProducts,
      (res: any) => {
        showSuggest.value = true
        data.value = res.data
      }
    ]
  // 图搜需要登录  做特殊处理 请求前confirmLogin一下
  if (req[0] === 'imageId') {
    confirmLoginWithNoCurShop(() => {
      loading.value = true
      return req[1](params.value).then((res: any) => {
        if (res.success) {
          num.value++
          requestAnimationFrame(() => req[2](res))
        }
        loading.value = false
      })
    })
  } else {
    return req[1]({
      ...params.value
    }).then((res: any) => {
      if (res.success) {
        num.value++
        requestAnimationFrame(() => req[2](res))
      }
    })
  }
})

const mixin = (obj1: any, obj2: any) => {
  Object.entries(obj1).forEach(([k, v]) => {
    obj2[k] = obj2[k] ?? v
  })
  return obj2
}

const store = useStore()
const route = useRoute()
const name = route.name
const params: any = ref()
const data: any = ref({})
const num = ref(0)
const componentData: any = reactive({
  shopDetail: null
})
/** 是不是国家站 */
const isNational = computed(() => (isJA() && !!route.query.national && !route.query.imageId && !route.query.productCode))

/** 是否登录 */
const isLogin = computed(() => store.getters.isLogin)

// 显示折扣
const showCkbDiscount = computed(() => route.query.platformType === 'AM' && keywordList.includes(String(route.query.keyword)) && !!store.getters.memberRate && !route.query.national)

/** H5打开搜索一下关键词，跳转到H5页 */
const searchKeywordHandle = () => {
  /** 获取url参数 */
  const userAgent = window.navigator.userAgent
  /** android终端 */
  const isAndroid =
    userAgent.indexOf('Android') > -1 || userAgent.indexOf('Linux') > -1
  /** ios终端 */
  const isIOS = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)

  const result = route.query

  /** H5 需要处理的关键词 */
  const wordList = [
    'レディース服',
    '子供服',
    'メンズ服',
    'サンダル',
    '水着',
    '紫外線対策グッズ',
    'ランジェリー・インナー',
    'ルームウェア',
    'アウトドア用品'
  ].map(v => [v, 'THE CKB厳選'])
    .concat([
      'cc6d36b33ebfce2573891edbbbfd5a74',
      '9a25961057c3e8428adbd654d88558e7',
      '39f1d22cb746ec79b3c3e0120e519930',
      '02d32e37bae7c39a45e536e861c01c08',
      'cf2294dd0e4be02034a6d34bf9223b5d',
      '5531a0d25f95b5d581c51c11fc2cfe2d',
      'a19b2222efafbabb726d586481297ace',
      'ba6c81d503ea742b328bffd8964448d9',
      'bce3572c7255e69980ec1bf528b33d24'
    ].map(v => [v]))

  // 当前关键词arr
  const keywords = result?.keyword?.toString().split(/\+|\s+/)
  const keywordFlag = wordList.some((words) => words.every(word => keywords?.includes(word)))
  //
  // const env = window.location.href.split('://')[1].split('.theckb')[0]
  // const isTest = ['test01', 'test02', 'test03', 'pre'].includes(env.split('-')[0])
  const params = window.location.href.split('?')[1] + `&isLogin=${isLogin.value}`
  if (keywordFlag && (isAndroid || isIOS)) {
    console.log(`https://h5.theckb.com/ckb-h5-goods/goodsList?${params}`)
    window.location.href = `https://h5.theckb.com/ckb-h5-goods/goodsList?${params}`
  }
}

const listLabelType = ref('shop')
watch(params, () => api(), { deep: true })
watch(
  route,
  (v) => {
    if (v.name !== name) return
    const query = { ...v.query }
    searchKeywordHandle()
    if (query.detailUrl) return
    if (query.descendOrder) {
      query.descendOrder = JSON.parse(query.descendOrder.toString())
    }
    // 是否1688
    const is1688 = (keywordList.includes(String(query.keyword)) && query.platformType === 'AM')
    if (route.query.shopCode && route.query.shopCode !== '') {
      // 店铺列表
      params.value = mixin(
        {
          langType: 1,
          sortType: '',
          descendOrder: true,
          sellPriceStart: '',
          sellPriceEnd: '',
          pageNum: 1,
          pageSize: 100
        },
        query
      )
    } else {
      if (!is1688) {
        delete query.isCkbDiscount
      } else {
        showSuggest.value = true
      }
      const filtersList = query.filters?.split(',') ?? []
      query.isOnePsale && (filtersList.push('isOnePsale'))
      params.value = mixin(
        {
          channel: '',
          platformType: '',
          productCategoryFrontendId: '',
          langType: 1,
          keyword: '',
          sortType: '',
          filters: '',
          descendOrder: true,
          sellPriceStart: '',
          sellPriceEnd: '',
          pageNum: 1,
          pageSize: 50,
          currentData: !is1688 ? '1' : undefined,
          stationCode
        },
        {
          ...query,
          channel: query.schannel,
          filters: filtersList.join(',')
        }
      )
    }

    listLabelType.value = (route.query.shopCode && route.query.shopCode !== '') || route.query.imageUrl ? 'shop' : ''
    // 是否展示提议
    // if (keywordList)
  },
  { immediate: true }
)


return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(isNational))
      ? (_openBlock(), _createBlock(Category, { key: 0 }))
      : _createCommentVNode("", true),
    (_unref(isNational))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(NationalSearch)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(SimilarGoods, {
        code: params.value.productCode
      }, null, 8, ["code"]),
      _createVNode(ImageSearchGoods, {
        "image-url": params.value.imageUrl
      }, null, 8, ["image-url"]),
      (_unref(route).query.shopCode && _unref(route).query.shopCode !== '')
        ? (_openBlock(), _createBlock(ShopHeader, {
            key: 0,
            shopDetail: _unref(componentData).shopDetail
          }, null, 8, ["shopDetail"]))
        : _createCommentVNode("", true),
      _createVNode(ListLabel, {
        params: params.value,
        type: listLabelType.value
      }, null, 8, ["params", "type"]),
      _createVNode(ListSort, {
        supplierRespDTO: _unref(componentData)?.supplierRespDTO,
        params: params.value,
        showCkbDiscount: _unref(showCkbDiscount)
      }, null, 8, ["supplierRespDTO", "params", "showCkbDiscount"]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(ListGrid, {
          pageNum: params.value.pageNum,
          "onUpdate:pageNum": _cache[0] || (_cache[0] = ($event: any) => ((params.value.pageNum) = $event)),
          pageSize: params.value.pageSize,
          "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((params.value.pageSize) = $event)),
          data: data.value,
          key: num.value,
          banner: params.value.platformType === 'AM' && !params.value.imageUrl
        }, {
          suggest: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              (showSuggest.value && _unref(isJA)() && _unref(isLogin))
                ? (_openBlock(), _createBlock(suggestDioalog, {
                    key: 0,
                    class: "suggestDioalog",
                    onClose: closeSuggest
                  }))
                : _createCommentVNode("", true),
              _createVNode(SuggestInput, {
                visible: showInputSuggest.value,
                onClose: sureSuggest
              }, null, 8, ["visible"])
            ])
          ]),
          _: 1
        }, 8, ["pageNum", "pageSize", "data", "banner"])
      ])
    ])
  ], 512)), [
    [_directive_loading, loading.value]
  ])
}
}

})